import React from 'react'

import PropTypes from 'prop-types'
import { Checkbox } from '@material-ui/core'

import useBulkSelection from 'hooks/useBulkSelection'

const BulkSelectionCheckbox = ({ itemId, label }) => {
  const { isSelected, toggle } = useBulkSelection()

  return (
    <Checkbox
      checked={isSelected(itemId)}
      onChange={() => toggle(itemId)}
      inputProps={{ 'aria-label': label }}
    />
  )
}

BulkSelectionCheckbox.propTypes = {
  itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string,
}

export default BulkSelectionCheckbox
